import React from 'react';
import { connect } from 'react-redux';

import { toggleSpinner } from 'apps/promo/actions/appAction';
import { toggleChat } from 'apps/promo/actions/chatAction';
import { CommonPagePromo } from 'apps/promo/components/common/CommonPagePromo';
import { LightDiskButton } from 'apps/promo/components/common/fromAuth/LightDiskButton/LightDiskButton';
import { LightHeaderPanel } from 'apps/promo/components/common/fromAuth/LightHeaderPanel/LightHeaderPanel';
import { LightIcon } from 'apps/promo/components/common/fromAuth/LightIcon/LightIcon';
import { LightText } from 'apps/promo/components/common/fromAuth/LightText/LightText';
import ZendeskHelpMobileSearch from 'apps/promo/components/help/ZendeskHelpMobileSearch';
import NotAuthBasePage from 'apps/promo/components/NotAuthBasePage';
import { getHelpCenterUrl, useGetQueryParams } from 'apps/promo/components/utils';
import { getLangCountryPrefix } from 'apps/promo/helpers/utils';

import styles from './ZendeskHelpMobile.module.css';

const ZendeskHelpMobileCategoryPage = (props) => {
    const category = props.category;
    const url = `${getLangCountryPrefix(props.lang, props.country)}/help-mobile`;
    const urlParams = useGetQueryParams();

    const filteredSections = props.sections?.filter((section) => {
        return section.category_id === category?.id && !section.directLink;
    });

    const sections = filteredSections.map((item) => {
        return (
            <a className={styles.mobileHelpLink} key={item.id} href={getHelpCenterUrl(`${url}/category/${item.category_id}/section/${item.id}`, urlParams)}>
                <LightText>{item.name}</LightText>
                <LightIcon name="chevron-right" color="primary" leftIndent={'16px'} />
            </a>
        );
    });

    return (
        <CommonPagePromo
            useThemeColor
            backUrl={category?.directLink ? null : getHelpCenterUrl(url, urlParams)}
            type={'tagA'}
            buttonId={'helpPageBackButton'}
            rightHeaderComponent={
                !urlParams.platform ? (
                    <LightDiskButton
                        type={'tagA'}
                        href={props.backUrl}
                        onClick={() => {
                            props.toggleSpinner(true);
                            sessionStorage?.removeItem('prevUrl');
                        }}
                        iconName={'cross'}
                    />
                ) : null
            }
        >
            <LightHeaderPanel useThemeColor title={category?.name} />
            <ZendeskHelpMobileSearch
                isMobilePlatform={urlParams.platform === 'ios' || urlParams.platform === 'android'}
                hasFixedIndent={urlParams.version === 'c3p0'}
            />
            {sections}
        </CommonPagePromo>
    );
};

const mapStateToProps = ({ extra }) => ({
    category: extra?.zendeskHelpData?.category,
    sections: extra?.zendeskHelpData?.sections,
    lang: extra.noAuthFooter?.language?.lang,
    country: extra.noAuthFooter?.language?.country,
});

export default connect(mapStateToProps, { toggleChat, toggleSpinner })(NotAuthBasePage(ZendeskHelpMobileCategoryPage));
